import React from 'react';
import { connect } from 'react-redux';
import {
  setStep,
} from '../duck/activeStep';
import {
  Button,
} from 'semantic-ui-react';

const steps = [
  // 'dealer',
  'systems',
  'term',
  'renter',
  'documents',
  'payment',
  'preview',
];

function ButtonNav(props) {
  const { step } = props;

  if (steps.indexOf(step) < 0) {
    return <div></div>
  }

  return (
    <div style={{ margin: '40px 0', display: 'flex', justifyContent: 'center' }}>
      {
        steps.indexOf(step) !== 0 &&
          <Button
            content="Previous"
            icon="arrow left"
            labelPosition="left"
            style={{ marginRight: '10px' }}
            onClick={() => props.onClick(steps[steps.indexOf(step) - 1])}
          />
      }
      {
        steps.indexOf(step) !== steps.length - 1 &&
          <Button
            content="Next"
            icon="arrow right"
            labelPosition="right"
            onClick={() => props.onClick(steps[steps.indexOf(step) + 1])}
          />
      }
    </div>
  );
}

function mapStateToProps(state) {
  return {
    step: state.activeStep,
  }
}

const mapDispatchToProps = dispatch => ({
  onClick: step => dispatch(setStep(step))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ButtonNav);
